import {
  ApartmentOutlined,
  CheckCircleFilled,
  FilterOutlined,
  PlusOutlined,
  TableOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { Tooltip, Button, Badge } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import GetFilteredUnitsApi from "../../api/GetFilteredUnits";
import GetUnitsTableApi from "../../api/units/GetUnitsTableApi";
import { SetupStatusApi } from "../../api/SetupStatusApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddTopUnitModal from "../../components/modal/add/AddTopUnitModal";
import AddUnitModal from "../../components/modal/add/AddUnitModal";
import OrganizationFilterModal from "../../components/modal/filters/OrganizationFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import OrganizationTable from "../../components/tables/OrganizationTable";
import OrganizationTree from "../../components/tree/OrganizationTree";
import { useSelector } from "react-redux";
import { permissionAbility } from "../../helpers/permissionHelpers";
// import { LIMIT_PER_PAGE } from "../../helpers/constants";

function Organization() {
  const [canStart, setCanStart] = useState(false);
  const [data, setData] = useState(false);
  const [tree, setTree] = useState(false);
  const [page, setPage] = useState(1);
  const [addModal, setAddModal] = useState(false);
  const [addTopModal, setAddTopModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;
  const pageLimit = 40;

  useEffect(() => {
    getSetupProgress();
    setFilterBy({ organizationLevel: "", unitName: "" });
  }, []);

  async function getSetupProgress() {
    const apiResponse = await SetupStatusApi();
    if (apiResponse.success) {
      if (apiResponse.data?.organizationLevels) {
        if (apiResponse.data?.units) {
          getUnits(1);
        } else {
          getTopUnit(1);
        }
      }
      setCanStart(true);
    }
  }

  /*When no units were added */
  async function getTopUnit(num) {
    setTableLoading(true);
    const apiResponse = await GetUnitsTableApi(num, pageLimit);
    if (apiResponse.success) {
      setData(apiResponse.data);
    }
  }

  async function getUnits(num) {
    setTableLoading(true);
    const apiResponse = await GetUnitsTableApi(num, pageLimit);
    if (apiResponse.success) {
      setData(apiResponse.data);
      setTableLoading(false);
      /*For the first user add */
      setPage(num);
    }
  }

  async function getFilteredUnits(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredUnitsApi(
      values.organizationLevel || "",
      values.unitName || "",
      num,
      pageLimit
    );
    if (apiResponse.success) {
      setFilterStatus(true);
      setData(apiResponse.data);
      setTableLoading(false);
      setFilterBy({
        organizationLevel: values.organizationLevel,
        unitName: values.unitName,
      });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilteredUnits(filterBy, num);
    } else {
      getUnits(num);
    }
  }

  function resetFilter() {
    setFilterStatus(false);
    getUnits(1);
    setFilterBy({ organizationLevel: "", unitName: "" });
  }

  const right = (
    <>
      {!tree && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
      {permissionAbility(userLevel, "organization", "add") && !tree && (
        <Tooltip placement="left" title={"Add Organization"}>
          <Button
            onClick={() => setAddModal(true)}
            shape="circle"
            className="ml-3"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const left = (
    <>
      <div className="pri-font text-lg">
        {"Organization (" + (data?.totalCount || 0) + ")"}
      </div>
      {tree ? (
        <Tooltip title={"Table view"}>
          <Button onClick={() => setTree(false)} className="ml-3">
            <TableOutlined />
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title={"Tree view"}>
          <Button onClick={() => setTree(true)} className="ml-3">
            <ApartmentOutlined />
          </Button>
        </Tooltip>
      )}
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            tree ? (
              <OrganizationTree />
            ) : (
              <OrganizationTable
                changePage={(num) => changeTablePage(num)}
                data={data}
                loading={tableLoading}
                page={page}
              />
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddUnitModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
        handleOk={() => getUnits(1)}
      />
      <AddTopUnitModal
        visible={addTopModal}
        handleCancel={() => setAddTopModal(false)}
        handleOk={() => getUnits(1)}
      />
      <OrganizationFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values, unit) => getFilteredUnits(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default Organization;
